
import React from "react";
import { useAuth } from "@/context/AuthContext";

const DashboardWelcome = () => {
  const { user } = useAuth();

  return (
    <div>
      <h1 className="text-2xl font-bold tracking-tight">Welkom, {user?.name}</h1>
      <p className="text-muted-foreground">
        {user?.role === "medewerker" && "Verwerk orders en houd voorraad bij"}
        {user?.role === "planner" && "Beheer planning en controleer voorraad"}
        {user?.role === "management" && "Bekijk rapportages en overzichten"}
      </p>
    </div>
  );
};

export default DashboardWelcome;
